const dev = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  WEBSITE_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
  CHATBOT_URL: "https://app-capmas-chatbot-api-ai-prod-g9gxffgrhsebe0bu.westeurope-01.azurewebsites.net",
};

const prod = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  WEBSITE_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
  CHATBOT_URL: "https://app-capmas-chatbot-api-ai-prod-g9gxffgrhsebe0bu.westeurope-01.azurewebsites.net",
};

const test = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  WEBSITE_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
  CHATBOT_URL: "https://app-capmas-chatbot-api-ai-prod-g9gxffgrhsebe0bu.westeurope-01.azurewebsites.net",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
